// 甜音web项目基础参数

/**
  引入axios
 */
  import Axios from 'axios';
  // import {message} from 'ant-design-vue'
  import { Toast } from 'vant'
  import NProgress from 'nprogress';//ajax请求进度条
  import 'nprogress/nprogress.css'
  import 'vant/lib/icon/local.css';
  
  import vconsole from 'vconsole'

  // 
  
  Toast.allowMultiple();//允许同时存在多个Toast
  // 添加请求拦截器
  Axios.interceptors.request.use(function (config) {
    // 在发送请求之前做些什么
    // console.log('axios请求前',config);
    // NProgress.start();//加载进度条开始
    return config;
  }, function (error) {
    console.log('请求异常',error);
    NProgress.done();//加载进度条完成
    // 对请求错误做些什么
    Toast.fail('发生一个错误');
    return Promise.reject(error);
  });
  
  // 添加响应拦截器
  Axios.interceptors.response.use(function (response) {
    // 对响应数据做点什么
    // console.log('axios响应前',response);
    NProgress.done();//加载进度条完成
    return response;
  }, function (error) {
    console.log('响应异常',error);
    NProgress.done();//加载进度条完成
    // 对响应错误做点什么
    Toast.fail('发生一个错误');
    return Promise.reject(error);
  });
  
  var _data = {
    accessToken: getQueryChinese('accessToken') || null, // token
    ev: getQueryString('test') == 'y' ? true : false,// 是否是测试环境
    _timer:null,
    /**
     * axios 
    */
    $axios:function(src,data){
      let loadingToast = null;
      if(src != 'circle/periodTask'){
        loadingToast = Toast.loading({
          forbidClick: true,
          message: '加载中',
          duration: 0
        });
      }
      const _data = {
        'appId': 'wanzi',
        'from': 'h5',
        'os': os,
        'appVersion': getQueryString('buildVersion')
      }
      if(getQueryString('appId')){
        _data.appId = getQueryString('appId');
      }
      const Data = Object.assign(_data,data);
      console.log(src+'--> ',Data);
      return new Promise((resolve, reject) => {
        Axios({
          method: 'POST',
          url: host + src,
          data: Data,
          headers:{
            'Authorization': this.accessToken
          }
        })
        .then((res)=>{
          console.log(src+'<-- ',JSON.parse(JSON.stringify(res.data)));
          if(loadingToast){
            loadingToast.clear();
          }
          if(data.jsCode == res.data.code){
            reject(res.data);
          }else if(res.data.code == 0){
            resolve(res.data);
          }else if(res.data.message){
            Toast(res.data.message);
          }else{
            Toast(res.data.code);
          }
        })
        .catch((error)=>{
          if(loadingToast){
            loadingToast.clear();
          }
          console.log('error',error);
        })
      })
    },
    /**客户端交互函数 */
    talk:function(fun_name,data){
      data = data ? typeof data != 'string' ? JSON.stringify(data) : data : data;
      console.log('talk -> ',fun_name, data);
      if(isiOS && !isWeixin && window.webkit){
        if(window.webkit.messageHandlers[fun_name]){
          window.webkit.messageHandlers[fun_name].postMessage(data ? data : '');
        }
      }
      if(isAndroid && !isWeixin && window.JsObjectFromTyAndroid){
        return data ? window.JsObjectFromTyAndroid[fun_name](data) : window.JsObjectFromTyAndroid[fun_name]();//调用	Android
      }
    },
    /**获取客户端token */
    getToken:function(){
      return new Promise((resolve, reject) => {
        if(this.accessToken){
          resolve(this.accessToken);
          return;
        }
        if(isAndroid){
          let token = this.talk('getToken');
          this.accessToken = token || this.accessToken;
          resolve(token);
        }
        if(isiOS){
          window.backToken = res => {
            this.accessToken = res || this.accessToken;
            resolve(res);
          }
          this.talk('getToken',{'backFun':'backToken'});
        }
      })
    },
    /**获取客户端环境 */
    getEv(){
      if(isAndroid){
        let ev = this.talk('getEv');
        this.ev = ev || this.ev;
      }
      if(isiOS){
        window.backEv = res => {
          this.ev = res || this.ev;
        }
        this.talk('getEv',{'backFun':'backEv'});
      }
    },
    /**头像增加处理参数 */
    cutAvatar:function(src) {
      src = src + '?imageView2/1/w/100/h/100/q/100!/format/gif';
      return src;
    },
    /**数字转为k */
    kFormatter:function(num) {
      return num > 999 ? (num/1000).toFixed(1) + 'k' : num
    },
    /**截取字符串 */
    cutStr:function(str,long) {
      if(str){
        if(str.length > long){
            return str.substr(0,long) + '...';
        }else{
            return str;
        }
      }else{
        return str;
      }
    },
    /**基础信息拼接 */
    infoStr:function(age,city,home){
      var str = '';
  
      const _list = [];
      age ? _list.push(age + '岁') : '';
      city ? _list.push(city) : '';
      home ? _list.push('老家' + home) : '';
      if(_list.length > 1){
        for(const i in _list){
          if(i < _list.length-1 && _list[i] != ''){
            _list[i] = _list[i] + '｜';
          }
          str = str + _list[i];
        }
      }
      return str;
    },
    /**计算时长*/
    timeCut:function(msd) {
      var time = parseFloat(msd);
      if (null!= time && ""!= time) {
          if (time > 60  && time < 60*60) {
              time = parseInt(time / 60.0) +"分钟"
              // + parseInt((parseFloat(time /60.0) - parseInt(time /60.0)) *60) +"<span>秒</span>";
          }else if (time >=60*60 && time <60*60*24) {
              time = parseInt(time /3600.0) +"小时"+ parseInt((parseFloat(time /3600.0) -
                  parseInt(time /3600.0)) *60) +"分钟"
              // + parseInt((parseFloat((parseFloat(time /3600.0) - parseInt(time /3600.0)) *60) -
              // parseInt((parseFloat(time /3600.0) - parseInt(time /3600.0)) *60)) *60) +"<span>秒</span>";
          }else if (time > 60*60*24) {
            time = parseInt(time/3600.0/24)+'天' + parseInt(parseFloat(time % (60*60*24))/3600.0) + '小时'
          } else {
              time = parseInt(time) +"秒";
          }
      }else{
          time = "0小时0分钟";
      }
      return time;
    },
    //时间戳转换为时间格式
    cutTime:function(str){
      function getzf(num){
        if(parseInt(num) < 10){
          num = '0'+num;
        }
        return num;
      }
      var oDate = new Date(str),
        oYear = oDate.getFullYear(),
        oMonth = oDate.getMonth()+1,
        oDay = oDate.getDate(),
        oHour = oDate.getHours(),
        oMin = oDate.getMinutes(),
        oSen = oDate.getSeconds(),
        oTime = oYear +'.'+ getzf(oMonth) +'.'+ getzf(oDay) +' '+ getzf(oHour) +':'+ getzf(oMin) +':'+getzf(oSen);//最后拼接时间
        // oTime = oYear +'.' + getzf(oMonth) +'.'+ getzf(oDay);//最后拼接时间
      return oTime;
    },
    //url重定向
    loadUrl:function(type,url,str){
  
      let _url = ''
      if(type != 'route'){
        _url = url + '?v=' + parseInt(Math.random()*1000000) + str + '&appId=' + getQueryString('appId') || '';
      }
      if(type === 'URL'){
        var para = {};
        para.iosRoute = 'SXXiangqin://BaseWebVC?html=' + encodeURIComponent(_url);
        para.androidRoute = 'arouter://tcjy/activity/common_web?url=' + _url;
        this.talk('route','',para,'');
      }
      if(type === 'url'){
        window.location.href = _url;
      }
      if(type == 'route'){
        const para = {};
        para.iosRoute = url;
        para.androidRoute = url;
        this.talk('route','',para,'');
      }
  
    },
    //倒计时(s)
    setTimer:function(time,callback){
      const that = this;
      clearInterval(that._timer);
      that._timer = setInterval(function(){
        time--;
        if(time > 0){
          let m = Math.floor((time / 60 % 60)) < 10 ? '0' + Math.floor((time / 60 % 60)) : Math.floor((time / 60 % 60));
          let s = Math.floor((time % 60)) < 10 ? '0' + Math.floor((time % 60)) : Math.floor((time % 60));
          let result = m + ':' + s;
          result = s;
    　　   callback(result);
        }else{
          clearInterval(that._timer);
          callback(0);
        }
      },1000)
    },
    //截取数字成千
    sub_nums:function(nums) {
      if(nums.toString().length > 3){
        return (nums/1000).toFixed(2) + 'k';
      }else{
        return nums;
      }
    },
    
  }
  
  if( (getQueryString('test') == 'y' || getQueryString('test') == 'goOnline') && getQueryString('noCons') != 'y' ){
    
  }

  _data.getToken();

  export default _data;
  

